import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Input, Output, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { map, take, takeUntil } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import { acceptedFileTypesText, acceptedFileTypes } from 'app-models';
import { environment } from 'environment-configurations';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2$1 from 'ngx-toastr';
import * as i4 from 'reference-library';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i7 from 'angular-file';
import { ngfModule } from 'angular-file';
import * as i8 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i9 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i10 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { PrimengLibraryModule } from 'primeng-library';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class FileUploadDeafultLibraryService {
    constructor(http) {
        this.http = http;
        this.uploaded$ = new BehaviorSubject({});
        this.deletedfile$ = new BehaviorSubject({});
    }
    genericUploadDocument(useCase, useCaseId, categoryName, entityId, fileCategory, otherName, payload, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        if (familyId) {
            appendUrl += appendUrl ? `&familyId=${familyId}` : `?familyId=${familyId}`;
        }
        //const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        return this.http.post(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}${appendUrl}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericPassPortUploadDocument(useCase, useCaseId, categoryName, entityId, fileCategory, otherName, payload, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        if (familyId) {
            appendUrl += appendUrl ? `&familyId=${familyId}` : `?familyId=${familyId}`;
        }
        //const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}${appendUrl}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericDeletePassportUploadDocument(useCase, useCaseId, categoryName, fileCategory, fileId, entityId, useEntityId, isEntityBasedDelete) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const fileIdTobePassed = (isEntityBasedDelete) ? '' : fileId;
        return this.http.delete(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}/fileCategory/${fileCategory}/${fileIdTobePassed}`).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericGetPassportUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericGetPetitionUploadDocument(petitionId, categoryCode, fileCategoryCode, entityId, otherName, payload) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        return this.http.post(`/document/category/fileCategory/${petitionId}/${categoryCode}/${fileCategoryCode}/${entityId}${appendUrl}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    generiBankUploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/upload/bankDetails/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericW4UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/w4formsupload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    genericForm16UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/form16upload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericPetitionGetUploadDocument(petitionId, categoryCode) {
        return this.http.get(`/petition/getDocuments/${petitionId}/${categoryCode}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericBankGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbUploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericW4GetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbW4UploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericDeleteUploadDocument(useCase, useCaseId, categoryName, fileCategory, fileId, entityId, useEntityId, isEntityBasedDelete) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const fileIdTobePassed = (isEntityBasedDelete) ? '' : fileId;
        return this.http.delete(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}/fileCategory/${fileCategory}/${fileIdTobePassed}`).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericPetitionDeleteUploadDocument(visaType, caseType, caseId, documentId) {
        if (caseType == 'Perm') {
            caseType = 'perm';
        }
        caseType = this.toEncrypt(caseType);
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/document/${documentId}`).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    deleteBankFileFromDocumentList(empId) {
        return this.http.delete(`/formBuilder/employee/bankDetails/delete/${empId}`).pipe(map((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    deleteW4FileFromDocumentList(empId, categoryName, fileCategory) {
        return this.http.delete(`/formBuilder/employee/w4Details/delete/${empId}/category/${categoryName}/fileCategory/${fileCategory}`).pipe(map((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    getEntitySpecificUploadDocument(useCase, useCaseId, categoryName, entity) {
        // console.log(entity);
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entity}`).pipe(map((response) => response));
    }
    uploaded() {
        this.uploaded$.next(true);
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    /**
     * New API
     */
    immigrationDocumentUpload(gcPermOrI140Id, categoryCode, fileCategoryCode, entityId, type, payload) {
        type = this.toEncrypt(type);
        return this.http.post(`/document/category/fileCategory/${gcPermOrI140Id}/${categoryCode}/${fileCategoryCode}/${entityId}/${type}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    immigrationGetDocumentUpload(gcVisaType, gcPermI140I130Id, categoryCode) {
        gcVisaType = this.toEncrypt(gcVisaType);
        return this.http.get(`/gcCase/getDocuments/${gcVisaType}/${gcPermI140I130Id}/${categoryCode}`);
    }
    genericGetPetitionUploadDocumentI130(petitionId, caseType, categoryCode, fileCategoryCode, entityId, type, otherName, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        let url = `/document/category/fileCategory/${petitionId}/${categoryCode}/${fileCategoryCode}/${entityId}/${type}${profileFamilyString}`;
        if (caseType === 'I485') {
            url = `/document/category/fileCategory/${petitionId}/${categoryCode}/${fileCategoryCode}/${entityId}${profileFamilyString}`;
        }
        return this.http.post(url, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericPetitionGetUploadDocumentI130(gcVisaType, gcPermI140I130Id, categoryCode) {
        return this.http.get(`/gcCase/getDocuments/${gcVisaType}/${gcPermI140I130Id}/${categoryCode}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
}
FileUploadDeafultLibraryService.ɵfac = function FileUploadDeafultLibraryService_Factory(t) { return new (t || FileUploadDeafultLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
FileUploadDeafultLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: FileUploadDeafultLibraryService, factory: FileUploadDeafultLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadDeafultLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", type_r15.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", type_r15.name, " ");
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 15, 16);
    i0.ɵɵlistener("ngModelChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(4); return ctx_r16.fileCategory = $event; })("change", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_Template_select_change_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(4); return ctx_r18.setOtherNameEmpty(); });
    i0.ɵɵelementStart(2, "option", 17);
    i0.ɵɵtext(3, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_option_4_Template, 2, 2, "option", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngModel", ctx_r11.fileCategory);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.documentTypes);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_input_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 20);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", ctx_r12.selectedDocType);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtext(3, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_select_4_Template, 5, 2, "select", 13);
    i0.ɵɵtemplate(5, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_input_5_Template, 1, 1, "input", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) == 1);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "label", 22);
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 23);
    i0.ɵɵlistener("ngModelChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r8.otherName);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "button", 24);
    i0.ɵɵlistener("filesChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_4_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return ctx_r21.files = $event; });
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4, " Browse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 26);
    i0.ɵɵtext(6, "Max file size is 10 MB | PDF file type is allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r9.entityId === 0 || !ctx_r9.fileCategory || ctx_r9.family && !ctx_r9.familyId)("accept", ctx_r9.acceptFileType)("files", ctx_r9.files);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 33);
    i0.ɵɵtext(1, "upload_file");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "w-200": a0 }; };
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelementStart(2, "button", 28);
    i0.ɵɵlistener("filesChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.files = $event; })("filesChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(3); return ctx_r26.onFileSelected($event); });
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtemplate(5, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_mat_icon_5_Template, 2, 0, "mat-icon", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 31);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 32);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, ctx_r10.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r10.entityId === 0 || !ctx_r10.fileCategory || ctx_r10.inputMultipleFlag === null || ctx_r10.inputMultipleFlagFed === null || ctx_r10.inputMultipleFlagState === null || ctx_r10.family && !ctx_r10.familyId || ctx_r10.fileCategory === "OTHER" && ctx_r10.otherName.trim() === "")("accept", ctx_r10.acceptFileType)("files", ctx_r10.files);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.buttonOnlyMode);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.singleFileTypeName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.acceptedTypesText);
} }
const _c1 = function (a0) { return { "fileDahedBorderBox": a0 }; };
const _c2 = function (a0) { return { "marginTop": a0 }; };
function FileUploadDeafultLibraryComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_1_Template, 6, 2, "div", 6);
    i0.ɵɵtemplate(2, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_2_Template, 4, 1, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_4_Template, 7, 3, "div", 9);
    i0.ɵɵtemplate(5, FileUploadDeafultLibraryComponent_ng_template_0_div_0_div_5_Template, 10, 9, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.documentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fileCategory === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMultiple);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isMultiple);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_ngfFormData_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 34);
    i0.ɵɵlistener("FormDataChange", function FileUploadDeafultLibraryComponent_ng_template_0_ngfFormData_1_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r3.files)("FormData", ctx_r3.uploadedFilesData);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_2_tr_22_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngfBackground", item_r30);
} }
const _c3 = function () { return ["image/gif", "image/png", "image/jpeg"]; };
function FileUploadDeafultLibraryComponent_ng_template_0_div_2_tr_22_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtemplate(2, FileUploadDeafultLibraryComponent_ng_template_0_div_2_tr_22_div_2_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(3, "strong", 48);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 49);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 49);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 50);
    i0.ɵɵelementStart(11, "div", 51);
    i0.ɵɵelementStart(12, "div", 52);
    i0.ɵɵelementStart(13, "span", 53);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_0_div_2_tr_22_Template_span_click_13_listener() { i0.ɵɵrestoreView(_r35); const i_r31 = ctx.index; const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.files.splice(i_r31, 1); });
    i0.ɵɵelement(14, "i", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    const i_r31 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(10, _c3).indexOf(item_r30.type) >= 0);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "itemName", i_r31, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r30.name);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "itemType", i_r31, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r30.type, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "itemSize", i_r31, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 7, item_r30.size / 1024 / 1024, ".2"), " MB ");
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "h5", 36);
    i0.ɵɵtext(3, "Files To Be Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 37);
    i0.ɵɵelementStart(5, "div", 38);
    i0.ɵɵelementStart(6, "button", 39);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_0_div_2_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.files.length = 0; });
    i0.ɵɵelement(7, "i", 40);
    i0.ɵɵelementStart(8, "span", 41);
    i0.ɵɵtext(9, "Remove all");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "table", 42);
    i0.ɵɵelementStart(11, "thead");
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelementStart(13, "th", 43);
    i0.ɵɵtext(14, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th", 44);
    i0.ɵɵtext(16, "Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th", 45);
    i0.ɵɵtext(18, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th", 46);
    i0.ɵɵtext(20, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "tbody");
    i0.ɵɵtemplate(22, FileUploadDeafultLibraryComponent_ng_template_0_div_2_tr_22_Template, 15, 11, "tr", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "ngfFormData", 34);
    i0.ɵɵlistener("FormDataChange", function FileUploadDeafultLibraryComponent_ng_template_0_div_2_Template_ngfFormData_FormDataChange_23_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r4.files.length);
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngForOf", ctx_r4.files);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("files", ctx_r4.files)("FormData", ctx_r4.uploadedFilesData);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 64);
    i0.ɵɵtext(1, " Actions ");
    i0.ɵɵelementEnd();
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 71);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r50); const item_r41 = i0.ɵɵnextContext(3).$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.openDoc(item_r41); });
    i0.ɵɵelementStart(1, "mat-icon", 72);
    i0.ɵɵtext(2, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵtemplate(1, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template, 3, 0, "span", 70);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelement(1, "file-download-library", 73);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", item_r41.fileLocationName)("Path", ctx_r45.envPath + item_r41.fileLocation.substring(23));
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelementStart(1, "span", 71);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); const i_r42 = ctx_r54.index; const item_r41 = ctx_r54.$implicit; const ctx_r53 = i0.ɵɵnextContext(3); return ctx_r53.deleteFiles(i_r42, item_r41); });
    i0.ɵɵelementStart(2, "mat-icon", 74);
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 50);
    i0.ɵɵelementStart(1, "div", 67);
    i0.ɵɵtemplate(2, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template, 2, 1, "div", 68);
    i0.ɵɵtemplate(3, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template, 2, 2, "div", 68);
    i0.ɵɵtemplate(4, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template, 4, 0, "div", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext().$implicit;
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r43.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation && ctx_r43.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.isDeleteEnabled);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵelementStart(3, "a", 65);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r58); const item_r41 = ctx.$implicit; const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.openDoc(item_r41); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 49);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 49);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_td_10_Template, 5, 3, "td", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const i_r42 = ctx.index;
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "fileName", i_r42, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r41.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "fileCategory", i_r42, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r41.fileCategory.code === "OTHER" ? item_r41.fileCategoryOtherName ? item_r41.fileCategoryOtherName : item_r41.fileCategory.name : item_r41.fileCategory.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "fileSize", i_r42, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(9, 7, item_r41.fileSize / 1024 / 1024, ".2"), " MB");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.isViewEnabled || ctx_r40.isDownloadEnabled || ctx_r40.isDeleteEnabled);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "h5", 56);
    i0.ɵɵtext(2, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 57);
    i0.ɵɵelementStart(4, "thead");
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelementStart(6, "th", 58);
    i0.ɵɵtext(7, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 59);
    i0.ɵɵtext(9, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 60);
    i0.ɵɵtext(11, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, FileUploadDeafultLibraryComponent_ng_template_0_div_3_th_12_Template, 2, 0, "th", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tbody", 62);
    i0.ɵɵtemplate(14, FileUploadDeafultLibraryComponent_ng_template_0_div_3_tr_14_Template, 11, 10, "tr", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", ctx_r5.isViewEnabled || ctx_r5.isDownloadEnabled || ctx_r5.isDeleteEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.listFiles)("ngForTrackBy", ctx_r5.trackItem);
} }
function FileUploadDeafultLibraryComponent_ng_template_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelementStart(1, "h5", 76);
    i0.ɵɵtext(2, "No Documents Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FileUploadDeafultLibraryComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FileUploadDeafultLibraryComponent_ng_template_0_div_0_Template, 6, 10, "div", 1);
    i0.ɵɵtemplate(1, FileUploadDeafultLibraryComponent_ng_template_0_ngfFormData_1_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(2, FileUploadDeafultLibraryComponent_ng_template_0_div_2_Template, 24, 4, "div", 3);
    i0.ɵɵtemplate(3, FileUploadDeafultLibraryComponent_ng_template_0_div_3_Template, 15, 3, "div", 3);
    i0.ɵɵtemplate(4, FileUploadDeafultLibraryComponent_ng_template_0_div_4_Template, 3, 0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isUploadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.family && ctx_r0.familyId == null && ctx_r0.isFileListRequired && ctx_r0.files && ctx_r0.files.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listFiles && ctx_r0.listFiles.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.listFiles || ctx_r0.listFiles && ctx_r0.listFiles.length === 0);
} }
function FileUploadDeafultLibraryComponent_ng_template_1_ngfFormData_0_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 34);
    i0.ɵɵlistener("FormDataChange", function FileUploadDeafultLibraryComponent_ng_template_1_ngfFormData_0_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r59.files)("FormData", ctx_r59.uploadedFilesData);
} }
const _c4 = function (a0) { return { "disabled": a0 }; };
function FileUploadDeafultLibraryComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "button", 80);
    i0.ɵɵlistener("filesChange", function FileUploadDeafultLibraryComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.files = $event; })("filesChange", function FileUploadDeafultLibraryComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.onFileSelected($event); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 81);
    i0.ɵɵtext(4, "Max file size is 10 MB | PDF file type is allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4, ctx_r60.entityId === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r60.entityId === 0 || !ctx_r60.fileCategory)("accept", ctx_r60.acceptFileType)("files", ctx_r60.files);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r60.singleFileTypeName);
} }
function FileUploadDeafultLibraryComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "span", 83);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "file-download-library", 84);
    i0.ɵɵelementStart(4, "mat-icon", 85);
    i0.ɵɵlistener("click", function FileUploadDeafultLibraryComponent_ng_template_1_div_2_Template_mat_icon_click_4_listener() { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(2); return ctx_r67.deleteFiles(0, ctx_r67.listFiles[0]); });
    i0.ɵɵtext(5, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r61.listFiles[0].fileNameWithExtension);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", ctx_r61.listFiles[0].fileLocation.substring(23))("Path", ctx_r61.envPath + ctx_r61.listFiles[0].fileLocation.substring(23));
} }
function FileUploadDeafultLibraryComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FileUploadDeafultLibraryComponent_ng_template_1_ngfFormData_0_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(1, FileUploadDeafultLibraryComponent_ng_template_1_div_1_Template, 5, 7, "div", 77);
    i0.ɵɵtemplate(2, FileUploadDeafultLibraryComponent_ng_template_1_div_2_Template, 6, 3, "div", 78);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.listFiles || ctx_r1.listFiles && ctx_r1.listFiles.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.listFiles && ctx_r1.listFiles.length > 0);
} }
class FileUploadDeafultLibraryComponent {
    constructor(uploadDocumentService, toastr, dialog, changeDetectorRef, referenceLibraryService) {
        this.uploadDocumentService = uploadDocumentService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.fileUploadSuccess = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.documentTypes = [];
        this.files = [];
        this.listFiles = [];
        this.categoryName = 'BENEDUDOC';
        this.displayedColumns = ['name', 'documentType', 'size'];
        this.dataSource = [];
        this.fileCategory = '';
        this.otherName = '';
        this.showSpecify = false;
        this.useEntityId = false;
        this.isEntityBasedDelete = false;
        this.selectedDocType = '';
        this.isViewEnabled = true;
        this.isDownloadEnabled = true;
        this.isDeleteEnabled = true;
        this.isUploadEnabled = true; // IM 3926
        this.subcriptions = [];
        this.acceptedTypesText = acceptedFileTypesText;
        this.files = [];
        this.isMultiple = false;
        this.acceptFileType = acceptedFileTypes; // Acceptable types: application/pdf, image/*
        this.isFileListRequired = true;
        this.documentTypeRequired = false;
        this.docummentTypeCode = null;
        this.useCase = '';
        this.useCaseId = 0;
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
        var retrievedObject = sessionStorage.getItem('primaryData');
        this.primaryData = JSON.parse(retrievedObject);
        this.primaryData;
    }
    ngOnInit() {
        this.envPath = environment.docs;
    }
    ngOnChanges(e) {
        if (e.configurations && e.configurations.currentValue) {
            this.isMultiple = false;
            this.singleFileTypeName = e.configurations.currentValue.singleFileTypeName ? e.configurations.currentValue.singleFileTypeName : 'Browse';
            this.buttonOnlyMode = e.configurations.currentValue.buttonOnlyMode ? e.configurations.currentValue.buttonOnlyMode : false;
            this.acceptFileType = e.configurations.currentValue.fileType;
            this.isFileListRequired = e.configurations.currentValue.isFileListRequired;
            this.categoryName = e.configurations.currentValue.categoryName;
            this.entityId = e.configurations.currentValue.entityId;
            this.inputMultipleFlag = e.configurations.currentValue.inputMultipleFlag;
            this.inputMultipleFlagState = e.configurations.currentValue.inputMultipleFlagState;
            this.inputMultipleFlagFed = e.configurations.currentValue.inputMultipleFlagFed;
            this.fileCategory = e.configurations.currentValue.fileCategory;
            this.listFiles = e.configurations.currentValue.listUploadedFiles ?
                e.configurations.currentValue.entityType ?
                    e.configurations.currentValue.listUploadedFiles.filter(x => x[e.configurations.currentValue.entityType] == this.entityId) :
                    e.configurations.currentValue.listUploadedFiles.filter(x => x.entityId == this.entityId) : [];
            this.documentTypeRequired = e.configurations.currentValue.documentTypeRequired;
            this.docummentTypeCode = e.configurations.currentValue.docummentTypeCode;
            this.useCase = e.configurations.currentValue.useCase;
            this.useCaseId = e.configurations.currentValue.useCaseId;
            this.useEntityId = (e.configurations.currentValue.useEntityId) ? e.configurations.currentValue.useEntityId : false;
            this.isEntityBasedDelete = (e.configurations.currentValue.isEntityBasedDelete) ?
                e.configurations.currentValue.isEntityBasedDelete : false;
            this.isViewEnabled = (e.configurations.currentValue.isViewEnabled === false) ? false : true;
            this.isDownloadEnabled = (e.configurations.currentValue.isDownloadEnabled === false) ? false : true;
            this.listFiles = this.listFiles.map((_e) => {
                _e.fileLocationName = (this.isFBUser && _e.fileLocation) ? _e.fileLocation.split('/').slice(-1)[0] : _e.fileLocation.substring(23);
                return _e;
            });
            this.isDeleteEnabled = (e.configurations.currentValue.isDeleteEnabled === false) ? false : true;
            this.isUploadEnabled = (e.configurations.currentValue.isUploadEnabled === false) ? false : true;
            this.petitionOutcomeId = e.configurations.currentValue.petitionOutcomeId ? e.configurations.currentValue.petitionOutcomeId : null;
            this.singleButtonUpload = e.configurations.currentValue.singleButtonUpload ? e.configurations.currentValue.singleButtonUpload : false;
            this.familyId = e.configurations.currentValue.familyId ? e.configurations.currentValue.familyId : null;
            this.family = e.configurations.currentValue.family ? e.configurations.currentValue.family : false;
            if (this.docummentTypeCode) {
                if (this.documentTypeRequired) {
                    this.fileCategory = '';
                }
                this.getDocumentTypeList();
            }
            // Refresh the To be uploaded files list
            if (this.fileCategory === '') {
                this.files = [];
            }
        }
        if (e.primaryData && e.primaryData.currentValue) {
            this.inputData = e.primaryData.currentValue;
        }
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    getDocumentTypeList() {
        this.subcriptions[this.subcriptions.length] =
            this.referenceLibraryService.getReferenceDataWithoutAuthentication(this.docummentTypeCode)
                .subscribe((response) => {
                this.referenceLibraryService.translateArray(response, 'name')
                    .then(translated => {
                    this.documentTypesTemp = translated;
                })
                    .catch(error => console.error("Translation error:", error));
                if (this.petitionOutcomeId) {
                    switch (this.petitionOutcomeId) {
                        case 'APPROVED':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'APPROVAL');
                            break;
                        case 'RFE':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'RFE');
                            break;
                        case 'NOID':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'NOID');
                            break;
                        case 'DENIED':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'DENIAL');
                            break;
                        case 'PETWITHDRAW':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'WITHDRWACK' || x.code === 'WITHDRAW');
                            break;
                        case 'GET_RECEIPT':
                            this.documentTypes = this.documentTypesTemp.filter(x => x.code === 'RECNOTC');
                            break;
                        default:
                            this.documentTypes = this.documentTypesTemp;
                            break;
                    }
                }
                else {
                    this.documentTypes = [...this.documentTypesTemp];
                }
                if (this.documentTypes && this.documentTypes.length === 1) {
                    this.fileCategory = this.documentTypes[0].code;
                    this.selectedDocType = this.documentTypes[0].name;
                }
                else {
                    this.selectedDocType = '';
                }
                this.translet();
            });
    }
    uploadFiles() {
        if (this.documentTypeRequired) {
            if (this.fileCategory) {
                if (this.files[this.files.length - 1].size <= 10485760) {
                    if (this.categoryName === 'BANKDETAILSDOC' || this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE' || this.categoryName === 'FORM16DETAILSDOC') {
                        this.uploadFinancials();
                    }
                    else if (this.categoryName !== 'BENGREENCARD') {
                        this.uploadDocument();
                    }
                    else {
                        if (this.family && this.familyId == null) {
                        }
                        else {
                            this.uploadDocument();
                        }
                    }
                }
                else {
                    this.files = [];
                    CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
                }
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Select a document type');
            }
        }
        else {
            if (this.files[this.files.length - 1].size <= 10485760) {
                this.uploadDocument();
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
            }
        }
        this.translet();
    }
    uploadDocument() {
        var _a, _b, _c, _d, _f;
        const familyId = this.familyId || this.configurations.familyId || (this.primaryData ? this.primaryData.familyId : null);
        if (this.categoryName === 'BENIMMDOC' || (this.categoryName === 'BENLICDOC' && !this.isWizard) || (this.categoryName === 'BENEDUDOC' && !this.isWizard) || (this.categoryName === 'BENTRGDOC' && !this.isWizard) || (this.categoryName === 'BENWEDOC' && !this.isWizard)) {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.fileCategory, this.otherName, this.uploadedFilesData, familyId)
                .subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, familyId)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.translet();
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else if (this.categoryName === 'BENPASSDOC' || this.categoryName === 'BENGREENCARD') {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPassPortUploadDocument('beneficiary', this.useCaseId, this.categoryName, this.entityId, this.fileCategory, this.otherName, this.uploadedFilesData, familyId)
                .subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPassportUploadDocument('beneficiary', this.useCaseId, this.categoryName, this.entityId, this.useEntityId, familyId)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.translet();
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    // this.toastr.error(response['message']);
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else if ((((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.caseType) === 'I140' || ((_c = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'perm') && (this.categoryName === 'BENEDUDOC' || this.categoryName === 'BENTRGDOC' || this.categoryName === 'BENLICDOC' || this.categoryName === 'BENWEDOC')) {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.immigrationDocumentUpload(this.primaryData.caseId, this.categoryName, this.fileCategory, this.entityId, this.primaryData.caseType, this.uploadedFilesData)
                .subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    this.translet();
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.immigrationGetDocumentUpload(this.primaryData.caseType, this.primaryData.caseId, this.categoryName)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else if (((_d = this.inputData) === null || _d === void 0 ? void 0 : _d.caseType) === 'I130') {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPetitionUploadDocumentI130(this.inputData.caseId, this.inputData.caseType, this.categoryName, this.fileCategory, this.entityId, this.primaryData.caseType, this.otherName, this.uploadedFilesData, this.primaryData.familyId).subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    let getURL = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName);
                    if (this.categoryName == 'BENWEDOC') {
                        getURL = this.uploadDocumentService.genericPetitionGetUploadDocumentI130(this.inputData.caseType || this.inputData.casetype, this.inputData.caseId, this.categoryName);
                    }
                    this.subcriptions[this.subcriptions.length] = getURL
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPetitionUploadDocument((_f = this.inputData) === null || _f === void 0 ? void 0 : _f.caseId, this.categoryName, this.fileCategory, this.entityId, this.otherName, this.uploadedFilesData).subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
    }
    uploadFinancials() {
        if (this.categoryName === 'BANKDETAILSDOC') {
            this.uploadDocumentService.generiBankUploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleBankUploadResponse(response));
        }
        else if (this.categoryName === 'FORM16DETAILSDOC') {
            this.uploadDocumentService.genericForm16UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
        else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
            this.uploadDocumentService.genericW4UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
    }
    handleBankUploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlag = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    handleW4UploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlagState = null;
            this.inputMultipleFlagFed = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    deleteFiles(index, item) {
        const title = 'Confirm Deletion!';
        const message = 'Do you want to delete this record?';
        if (this.categoryName === 'BENIMMDOC' || ((this.categoryName === 'BENWEDOC' || this.categoryName === 'BENEDUDOC' || this.categoryName === 'BENTRGDOC' || this.categoryName === 'BENLICDOC') && !this.isWizard)) {
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericDeleteUploadDocument(this.useCase, this.useCaseId, item.fileCategory.group, item.fileCategory.code, item.id, this.entityId, this.useEntityId, this.isEntityBasedDelete)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
        else if (this.categoryName === 'BENPASSDOC' || this.categoryName === 'BENGREENCARD') {
            const title = 'Confirm';
            const message = 'Do you wish to Delete the File?';
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericDeletePassportUploadDocument('beneficiary', this.useCaseId, item.fileCategory.group, item.fileCategory.code, item.id, this.entityId, this.useEntityId, this.isEntityBasedDelete)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPassportUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
        else {
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionDeleteUploadDocument(this.inputData.visaType || this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    trackItem(index, item) {
        return item.id;
    }
    dialogueInitializer(title, message) {
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '40%',
            data: {
                update: { title, message },
                buttons: ['No', 'Yes']
            }
        });
        return dialogRef;
    }
    deleteBankDocumentHandler(item) {
        this.uploadDocumentService.deleteBankFileFromDocumentList(this.configurations.entityId).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.inputMultipleFlag = true;
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    deleteW4DocumentHandler(item) {
        this.uploadDocumentService.deleteW4FileFromDocumentList(this.configurations.entityId, this.categoryName, this.fileCategory).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    if (this.categoryName === 'W4FORMS') {
                        this.inputMultipleFlagFed = true;
                    }
                    else if (this.categoryName === 'W4FORMSSTATE') {
                        this.inputMultipleFlagState = true;
                    }
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    onFileSelected(e) {
        if (e && e.length > 0) {
            setTimeout(() => {
                this.uploadFiles();
            }, 500);
        }
    }
    setOtherNameEmpty() {
        this.otherName = '';
    }
    ngOnDestroy() {
        this.subcriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }
}
FileUploadDeafultLibraryComponent.ɵfac = function FileUploadDeafultLibraryComponent_Factory(t) { return new (t || FileUploadDeafultLibraryComponent)(i0.ɵɵdirectiveInject(FileUploadDeafultLibraryService), i0.ɵɵdirectiveInject(i2$1.ToastrService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.ReferenceLibraryService)); };
FileUploadDeafultLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FileUploadDeafultLibraryComponent, selectors: [["file-upload-deafult-library"]], inputs: { configurations: "configurations", primaryData: "primaryData", isWizard: "isWizard" }, outputs: { fileUploadSuccess: "fileUploadSuccess" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "ngIf"], ["class", "row", 3, "ngClass", 4, "ngIf"], ["postName", "file", 3, "files", "FormData", "FormDataChange", 4, "ngIf"], ["class", "pt-2 marginBottom", 4, "ngIf"], ["class", "pt-2 text-center marginBottom", 4, "ngIf"], [1, "row", 3, "ngClass"], ["class", "col-4 mt-1", 4, "ngIf"], ["class", "col-4 form-group", 4, "ngIf"], [1, "col-4", 3, "ngClass"], [4, "ngIf"], [1, "col-4", "mt-1"], [1, "form-group"], ["id", "docType1", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["class", "im-input mt-2 mw-100 d-block", "name", "fileCategoryType", "required", "", 3, "ngModel", "ngModelChange", "change", 4, "ngIf"], ["type", "text", "class", "im-input mt-2 mw-100 d-block", "readonly", "", 3, "value", 4, "ngIf"], ["name", "fileCategoryType", "required", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "ngModel", "ngModelChange", "change"], ["fileCategoryType", "ngModel"], ["value", "", "id", "selectItem", 1, "common-bene-class-for-translation"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["type", "text", "readonly", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "value"], [1, "col-4", "form-group"], ["id", "doc-type-name-1", 1, "common-bene-class-for-translation"], ["type", "text", 1, "im-input", 3, "ngModel", "ngModelChange"], ["type", "button", "multiple", "1", "ngfSelect", "", 1, "im-btn", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], ["id", "browse_1", 1, "common-bene-class-for-translation"], ["id", "max-size_1", 1, "label-cls", "single-file-upload", "d-block", "common-bene-class-for-translation"], [1, "form-group", "mb-0", 3, "ngClass"], ["type", "button", "ngfSelect", "", 1, "btn-primary", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], [1, "btnModeBtnContent"], ["class", "material-icons", 4, "ngIf"], ["id", "singleFileTypeName1", 1, "common-bene-class-for-translation"], ["id", "acceptedTypesText1", 1, "label-cls", "single-file-upload", "d-block", "common-bene-class-for-translation"], [1, "material-icons"], ["postName", "file", 3, "files", "FormData", "FormDataChange"], [1, "pt-2", "marginBottom"], ["id", "filestobeuploaded-1", 1, "common-bene-class-for-translation"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-sm", 3, "disabled", "click"], ["aria-hidden", "true", 1, "fa", "fa-trash"], ["id", "removeAll", 1, "common-bene-class-for-translation"], [1, "im-card-no-border-table"], ["id", "thName", 1, "common-bene-class-for-translation"], ["id", "thType", 1, "common-bene-class-for-translation"], ["id", "thSize", 1, "common-bene-class-for-translation"], ["id", "thActions", 1, "common-bene-class-for-translation"], [4, "ngFor", "ngForOf"], [1, "common-bene-class-for-translation", 3, "id"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], ["nowrap", ""], [1, "d-flex", "flex-row"], [1, "p-2", "padding0"], ["title", "Remove", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-trash", "fa-lg", "icn"], [1, "previewIcon", 3, "ngfBackground"], ["id", "listOfuploadedDic", 1, "heading", "common-bene-class-for-translation"], [1, "im-card-no-border-table", "file-upload-list", "table-striped-simple"], ["id", "docName1", 1, "common-bene-class-for-translation"], ["id", "docType222", 1, "common-bene-class-for-translation"], ["id", "docSize1", 1, "common-bene-class-for-translation"], ["class", "text-center common-bene-class-for-translation", "id", "docActions1", 4, "ngIf"], [1, "wrap-word"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["id", "docActions1", 1, "text-center", "common-bene-class-for-translation"], [1, "cursorPointer", "common-bene-class-for-translation", 3, "id", "click"], ["nowrap", "", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], [3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons"], [3, "fileName", "Path"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Delete Document", 1, "material-icons"], [1, "pt-2", "text-center", "marginBottom"], ["id", "noDocumentUploaded1", 1, "common-bene-class-for-translation"], ["class", "d-inline-block", 3, "ngClass", 4, "ngIf"], ["class", "d-inline-block", "class", "single-fileuploaded-view-holder", 4, "ngIf"], [1, "d-inline-block", 3, "ngClass"], ["type", "button", "matTooltipClass", "tooltip-bg", "ngfSelect", "", "id", "singleFileTypeName", 1, "btn", "btn-outline-primary", "single-file-upload", "common-bene-class-for-translation", 3, "disabled", "accept", "files", "filesChange"], ["id", "maxFile_1111_12", 1, "label-cls", "single-file-upload", "d-block", "common-bene-class-for-translation"], [1, "single-fileuploaded-view-holder"], ["id", "extention", 1, "file-uploaded", "common-bene-class-for-translation"], [1, "ml-3", "pr-2", 3, "fileName", "Path"], ["matTooltip", "Delete Document", "matTooltipClass", "tooltip-bg", 1, "material-icons", 3, "click"]], template: function FileUploadDeafultLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FileUploadDeafultLibraryComponent_ng_template_0_Template, 5, 5, "ng-template", 0);
        i0.ɵɵtemplate(1, FileUploadDeafultLibraryComponent_ng_template_1_Template, 3, 3, "ng-template", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.singleButtonUpload);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.singleButtonUpload);
    } }, directives: [i5.NgIf, i5.NgClass, i6.SelectControlValueAccessor, i6.RequiredValidator, i6.NgControlStatus, i6.NgModel, i6.NgSelectOption, i6.ɵangular_packages_forms_forms_z, i5.NgForOf, i6.DefaultValueAccessor, i7.ngfSelect, i8.MatIcon, i7.ngfFormData, i7.ngfBackground, i9.MatTooltip, i10.FileDownloadLibraryComponent], pipes: [i5.DecimalPipe], styles: [".marginTop[_ngcontent-%COMP%]{padding:30px 10px}.fileDahedBorderBox[_ngcontent-%COMP%]{border:1px dashed #d3d3d3;margin-bottom:10px}.padding0[_ngcontent-%COMP%]{padding:0!important}.file-upload-list[_ngcontent-%COMP%]{width:100%}.w-200[_ngcontent-%COMP%]{width:200px!important}.btnModeBtnContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;align-items:center}.file-upload-list[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{height:50px!important;text-transform:uppercase!important}.wrap-word[_ngcontent-%COMP%]{word-break:break-all}.marginBottom[_ngcontent-%COMP%]{margin-bottom:40px}.cursorPointer[_ngcontent-%COMP%]{cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadDeafultLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'file-upload-deafult-library',
                templateUrl: './file-upload-deafult-library.component.html',
                styleUrls: ['./file-upload-deafult-library.component.scss']
            }]
    }], function () { return [{ type: FileUploadDeafultLibraryService }, { type: i2$1.ToastrService }, { type: i1$1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: i4.ReferenceLibraryService }]; }, { configurations: [{
            type: Input
        }], fileUploadSuccess: [{
            type: Output
        }], primaryData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }] }); })();

class FileUploadDeafultLibraryModule {
}
FileUploadDeafultLibraryModule.ɵfac = function FileUploadDeafultLibraryModule_Factory(t) { return new (t || FileUploadDeafultLibraryModule)(); };
FileUploadDeafultLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: FileUploadDeafultLibraryModule });
FileUploadDeafultLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FileDownloadLibraryModule,
            CommonModule,
            MatListModule,
            MatButtonModule,
            MatTooltipModule,
            MatButtonToggleModule,
            MatIconModule,
            ngfModule,
            MatInputModule,
            MatSelectModule,
            FormsModule,
            MatFormFieldModule,
            InputTextModule,
            ReactiveFormsModule,
            MatSelectModule,
            ButtonModule,
            FileUploadModule,
            TableModule,
            DropdownModule,
            CheckboxModule,
            MatSelectModule,
            MatTableModule,
            NgbTooltipModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FileUploadDeafultLibraryModule, { declarations: [FileUploadDeafultLibraryComponent], imports: [PrimengLibraryModule,
        FileDownloadLibraryModule,
        CommonModule,
        MatListModule,
        MatButtonModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatIconModule,
        ngfModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        MatFormFieldModule,
        InputTextModule,
        ReactiveFormsModule,
        MatSelectModule,
        ButtonModule,
        FileUploadModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        MatSelectModule,
        MatTableModule,
        NgbTooltipModule], exports: [FileUploadDeafultLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadDeafultLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [FileUploadDeafultLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    FileDownloadLibraryModule,
                    CommonModule,
                    MatListModule,
                    MatButtonModule,
                    MatTooltipModule,
                    MatButtonToggleModule,
                    MatIconModule,
                    ngfModule,
                    MatInputModule,
                    MatSelectModule,
                    FormsModule,
                    MatFormFieldModule,
                    InputTextModule,
                    ReactiveFormsModule,
                    MatSelectModule,
                    ButtonModule,
                    FileUploadModule,
                    TableModule,
                    DropdownModule,
                    CheckboxModule,
                    MatSelectModule,
                    MatTableModule,
                    NgbTooltipModule
                ],
                exports: [FileUploadDeafultLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of file-upload-deafult-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FileUploadDeafultLibraryComponent, FileUploadDeafultLibraryModule, FileUploadDeafultLibraryService };
//# sourceMappingURL=file-upload-deafult-library.js.map
